import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Skeleton } from '../../../components/Skeleton';
import { useTheme } from '../../../contexts/ThemeContext';

export default function TalentsSkeleton() {
  const { colors } = useTheme();

  return (
    <View style={styles.container}>
      {/* Hero Banner Skeleton */}
      <Skeleton width="100%" height={340} borderRadius={12} />

      {/* Statistics Cards Row */}
      <View style={styles.row}>
        <View style={styles.flex}>
          <Skeleton width="100%" height={200} borderRadius={12} />
        </View>
        <View style={styles.flex}>
          <Skeleton width="100%" height={200} borderRadius={12} />
        </View>
        <View style={styles.flex}>
          <Skeleton width="100%" height={200} borderRadius={12} />
        </View>
      </View>

      {/* Specializations Header */}
      <Skeleton width={150} height={24} borderRadius={4} />

      {/* Specialization Cards */}
      <View style={styles.row}>
        {[1, 2, 3, 4].map(i => (
          <Skeleton key={i} width={280} height={180} borderRadius={8} />
        ))}
      </View>

      {/* Forum Banner */}
      <Skeleton width="100%" height={440} borderRadius={12} />

      {/* Teachers Table */}
      <View style={[styles.tableCard, { backgroundColor: colors.card, borderColor: colors.cardBorder }]}>
        <Skeleton width={120} height={24} borderRadius={4} />
        <Skeleton width="100%" height={300} borderRadius={8} />
      </View>

      {/* Students Table */}
      <View style={[styles.tableCard, { backgroundColor: colors.card, borderColor: colors.cardBorder }]}>
        <Skeleton width={140} height={24} borderRadius={4} />
        <Skeleton width="100%" height={300} borderRadius={8} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 20,
  },
  row: {
    flexDirection: 'row',
    gap: 20,
  },
  flex: {
    flex: 1,
  },
  tableCard: {
    borderRadius: 12,
    borderWidth: 1,
    padding: 16,
    gap: 16,
  },
});
